import moment from "moment";

export class Holiday {
  DateHoliday;
  HolidayDesc;
  HolidayType;
  AddBy;
  constructor() {
    this.DateHoliday = moment().format("YYYY-MM-DD");
    this.HolidayDesc = "";
    this.HolidayType = "";
    this.AddBy = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/Holiday.js